<template>
    <md-table-cell class="text-center" >
        {{this.formattedDate}}
    </md-table-cell>
</template>

<script>
    import moment from "moment";

    export default {
        name: "IndexTableCellDate",
        props:{
            date: {
                type: String,
                default: '',
                required: true,
            },
            dateFormat: {
                type: String,
                default: 'YYYY-MM-DD HH:mm',
            }

        },
        computed: {
            formattedDate(){
                return moment(new Date(this.date)).format(this.dateFormat);
            }
        }
    }
</script>

<style scoped>

</style>